import { Client, RefPolicy, RequestRefPolicy } from 'src/app/service/global.service';
import {AbstractController} from './abstract-controller';
import { Environment } from '../environment';

export class RefPoliciesController extends AbstractController {

    private readonly service:string="policy-management/api/v1.0";
    private readonly apiUrl: keyof Environment = "bwApiUrl";

    public async getRefPolicies():Promise<RefPolicy[]>{
        return await this.network.get(`${this.service}`+`/ref-policies`, this.apiUrl)
    }

    public async addRefPolicy(refPolicy:RequestRefPolicy):Promise<void>{
        await this.network.post(`${this.service}`+`/ref-policies`, refPolicy, this.apiUrl)
    }

    public async deleteRefPolicy(refPolicy: RefPolicy) {
        await this.network.delete(`${this.service}`+`/ref-policies/${refPolicy.id}`, this.apiUrl)
    }

    public async patchRefPolicy(requestRefPolicy: RequestRefPolicy) {
        await this.network.patch(`${this.service}`+`/ref-policies/${requestRefPolicy.id}`, requestRefPolicy , this.apiUrl)
    }

    public async getClientRefPolicies(client:Client):Promise<RefPolicy[]>{
        return await this.network.get(`${this.service}`+`/clients/${client.id}/ref-policies`, this.apiUrl)
    }
    public async addRefPolicyToClient(client:Client, refPolicy:RequestRefPolicy):Promise<void>{
        await this.network.post(`${this.service}`+`/clients/${client.id}/ref-policies`, refPolicy, this.apiUrl)
    }
    public async patchRefPolicyToClient(client:Client, refPolicy:RequestRefPolicy):Promise<void>{
        await this.network.patch(`${this.service}`+`/clients/${client.id}/ref-policies/${refPolicy.id}`, refPolicy, this.apiUrl)
    }
    public async deleteRefPolicyFromClient(client:Client, refPolicy:RefPolicy){
        await this.network.delete(`${this.service}`+`/clients/${client.id}/ref-policies/${refPolicy.id}`, this.apiUrl)
    }

    public filterListRefPolicies(listRefPolicies:RefPolicy[], type:string):RefPolicy[]{
        return listRefPolicies.filter((refPolicy: RefPolicy) => refPolicy.type === type)
    }
    
    public async synchroSDS(){
        return await this.network.get(`${this.service}`+`/detectors/sync`, this.apiUrl);
    }
}
